export default function Collection() {};

Collection.collect = function (items) {
    this.items = items;
    return this;
}

Collection.pluck = function (value, key) {
    var plucked = {};
    var count = 0;
    $(this.items).each(function () {
        var index = typeof key !== 'undefined' ? this[key] : count++;
        plucked[index] = this[value];
    });
    return plucked;
};

Collection.itemsOrNone = function () {
    var length = typeof this.items === 'object' ? Object.keys(this.items).length : this.items.length;
    return length ? this.items : ['None'];
};
